<template>
  <SelectComponent :value="value" class="user-select-modal" @input="$ev => $emit('input', $ev)" v-bind="$attrs">
    <template #item="{ item, scope }">
      <UserCard theme="list" :value="item" :subtitle="scope === 'input' ? subtitle : item.email">
        <template #custom>
          <slot v-if="scope === 'input'" :item="item" :scope="scope" name="custom" />
        </template>
      </UserCard>
    </template>
    <template #empty>
      <UserCard theme="list" :value="{ name: labels.notset }" />
    </template>
    <template #noresults="{ filter }">
      <div class="text--center">{{ $t('couldnotfindonquery', { query: filter.search }) }}</div>
    </template>
    <template #bottom>
      <div class="user-select-modal__add-user" v-if="$store.getters.hasAccess('admin')">
        {{ $t('lookingForAUserAdd') }}
        <router-link :to="{ name: 'user-create', query: { returnTo: $route.path } }">{{
          $t('createUser')
        }}</router-link>
      </div>
    </template>
  </SelectComponent>
</template>

<script>
import UserCard from '@/components/User/Card'
import SelectComponent from '@/components/Select/Modal'
import { mapi18n } from '@/i18n'

export default {
  props: {
    value: [Object, Array],
    subtitle: String,
  },
  computed: {
    ...mapi18n('labels', ['notset']),
  },
  components: {
    UserCard,
    SelectComponent,
  },
}
</script>

<style lang="scss">
.user-select-modal {
  &__add-user {
    text-align: center;
    color: css-alpha('dark', 0.5);
    font-size: 0.8em;
    padding: 1rem;

    a {
      display: block;
      margin-top: 5px;
    }
  }
}
</style>
